import { apiRequest } from "../apiRequest";

export const getRates = (data) => {
  return apiRequest(`/admin/payment/get`, "POST", data);
};

export const setRates = (data) => {
  return apiRequest(`/admin/payment/set`, "POST", data);
};
